import React, { Fragment, memo } from 'react';

import { DocumentContentTitle } from '@confluence/document-title/entry-points/DocumentContentTitle';
import { LoginIfAnonymous } from '@confluence/login-if-anonymous';
import { RestrictedPage } from '@confluence/no-permission/entry-points/RestrictedPage';

import { ContentExpansionContainer } from './styles';

type UnauthorizedScreenProps = {
	contentId: string;
	accessType: string;
};

export const UnauthorizedScreen = memo((props: UnauthorizedScreenProps) => (
	<Fragment>
		<LoginIfAnonymous />
		<ContentExpansionContainer>
			<DocumentContentTitle siteTitleOnly />
			<RestrictedPage {...props} />
		</ContentExpansionContainer>
	</Fragment>
));
